module.exports = __webpack_public_path__ + "static/Implant bridge intraoral before-43c854869f53bbf0863082619da954a7.jpg";